import VisualizarDadosCompra from './VisualizarDadosCompra';

export default VisualizarDadosCompra;
